import api from './api'
export default {
    post: function(parms) {
      return api.post('initiate-call',parms)
    },
    scPost: function(parms) {
      return api.post('sc-call',parms)
    },
    scList: function(parms) {
      return api.post('sc-list',parms)
    },
    
    
  }